import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { AiFillCaretUp, AiFillCaretDown } from "react-icons/ai";
import { MdCalendarToday, MdEventBusy, MdInfoOutline } from "react-icons/md";
import { SurveyStartDate, SurveyEndDate } from "../common/DateFormat";

const SurveyDescription = ({ IntroductionText, surveyDetails, surveyDescription }) => {
  const [description, setDescription] = useState(true);
  const [showAbout, setShowAbout] = useState(false);

  const hasDescription =
    surveyDescription &&
    typeof surveyDescription === "string" &&
    surveyDescription.trim() !== "" &&
    surveyDescription !== "<p><br></p>";

  return (
    <div className="header_bottom_sticky container">
      {description ? (
        <div className="survey-description-bar ">
          <Container fluid>
            <div className="survey-meta-wrapper">
              {/* Left: Status Badge & Timing Chips */}
              <div className="survey-meta-left">
                {/* Status Badge */}
                <div
                  className={`survey-status-badge ${
                    surveyDetails?.SurveyStatus === "Closed"
                      ? "survey-status-badge--closed"
                      : "survey-status-badge--active"
                  }`}
                >
                  <span className="status-dot" />
                  <span>{surveyDetails?.SurveyStatus === "Closed" ? "Closed" : "Active"}</span>
                </div>

                <div className="survey-meta-divider" />

                {/* Timing Chips */}
                <div className="timing-chips-group">
                  <div className="timing-chip timing-chip--start">
                    <div className="timing-chip-icon">
                      <MdCalendarToday />
                    </div>
                    <div className="timing-chip-content">
                      <SurveyStartDate start_date={surveyDetails?.StartDate} />
                    </div>
                  </div>

                  <div className="timing-chip timing-chip--end">
                    <div className="timing-chip-icon">
                      <MdEventBusy />
                    </div>
                    <div className="timing-chip-content">
                      <SurveyEndDate end_date={surveyDetails?.ExpiryDate} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Right: Actions */}
              <div className="survey-meta-right">
                {hasDescription && (
                  <button
                    type="button"
                    className={`survey-about-btn ${showAbout ? "active" : ""}`}
                    onClick={() => setShowAbout(!showAbout)}
                    title="Toggle survey details"
                  >
                    <MdInfoOutline />
                    <span>{showAbout ? "Hide Info" : "About Survey"}</span>
                  </button>
                )}

                <button
                  type="button"
                  className="survey-collapse-btn"
                  onClick={() => setDescription(false)}
                  title="Collapse bar"
                  aria-label="Collapse schedule bar"
                >
                  <AiFillCaretUp />
                </button>
              </div>
            </div>

            {/* Expandable Survey Description */}
            {hasDescription && showAbout && (
              <div className="survey-desc-panel">
                <div className="survey-desc-badge">About Survey</div>
                <div
                  className="survey-desc-text"
                  dangerouslySetInnerHTML={{ __html: surveyDescription }}
                />
              </div>
            )}
          </Container>
        </div>
      ) : (
        <div className="survey-expand-bar">
          <Container>
            <button
              type="button"
              className="survey-expand-pill"
              onClick={() => setDescription(true)}
              title="Show survey schedule"
            >
              <span
                className={`mini-dot ${
                  surveyDetails?.SurveyStatus === "Closed" ? "closed" : "active"
                }`}
              />
              <span className="expand-status">
                {surveyDetails?.SurveyStatus === "Closed" ? "Closed" : "Active"}
              </span>
              <span className="expand-sep">·</span>
              <span className="expand-label">Survey Schedule</span>
              <AiFillCaretDown className="expand-caret" />
            </button>
          </Container>
        </div>
      )}
    </div>
  );
};

export default SurveyDescription;
